import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { VehicleService } from 'src/app/core/services/vehicle.service';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.css'],
})
export class ImageGalleryComponent implements OnInit {
  @Input() currentImage: any;
  @Input() images: any[];
  @Input() currentIndex: number;
  @Input() vin = null;
  @Input() panorama: boolean;
  @Output() close = new EventEmitter();
  @Input() isCrop: boolean = false;
  @Input() isMarkerActive: boolean = false;

  @ViewChild('myPanoViewer', { static: false }) iframe: ElementRef;

  bigImage;
  isDownloading = false;
  isDragging: boolean = false;
  startPosition: any;
  imageWidth = 1920; // Replace with the actual width of your image
  viewportWidth = 889; // Width of the visible portion
  viewportHeight = 500; // Height of the visible portion
  markers: any[] = [];
  toggleMarkerInfo = false;
  currentMarker = null;
  selectedMarkerIndex: number | null = null;
  originalImageLoaded: boolean = false;
  imageMarkers = [];
  markersVisible = true;

  @ViewChild('image') image!: ElementRef<HTMLImageElement>;

  constructor(
    private vehicleService: VehicleService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private elementRef: ElementRef,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.bigImage = document.getElementById('preview') as HTMLElement;

    this.loadMarkers();
  }

  loadMarkers() {
    if (!this.isMarkerActive || !this.currentImage) return;

    const foundMarker = this.imageMarkers.find(
      (imageMarker) => imageMarker.imageId === this.currentImage.id
    );

    if (foundMarker) {
      this.markers = foundMarker.markers;
      return;
    }

    const fileType = this.currentImage?.previewFile?.type || 'original';
    this.markers = [];

    // this.markers = this.currentImage?.previewFile?.markers;

    this.vehicleService
      .getImageMarkers(this.currentImage.id, fileType)
      .subscribe(
        (res) => {
          this.markers = res;
          this.imageMarkers.push({
            imageId: this.currentImage.id,
            markers: res,
          });
        },
        (err) => {}
      );
  }

  leftSlide() {
    this.bigImage?.classList.add('animate');
    if (this.currentIndex === 0) {
      this.currentIndex = this.images.length;
    }
    setTimeout(() => {
      this.bigImage?.classList.remove('animate');
    }, 500);
    this.slideLeft();
  }

  slideLeft() {
    this.currentImage = this.images[this.currentIndex - 1];
    this.loadMarkers();

    this.originalImageLoaded = false;
    // this.loadImage();

    // this.addSelected(this.current - 1);
    this.currentIndex--;
    console.log(this.currentImage);
  }

  rightSlide() {
    this.bigImage?.classList.add('animate');
    if (this.currentIndex === this.images.length - 1) {
      this.currentIndex = -1;
    }
    setTimeout(() => {
      this.bigImage?.classList.remove('animate');
    }, 500);
    this.slideRight();
  }

  slideRight() {
    this.currentImage = this.images[this.currentIndex + 1];
    this.loadMarkers();

    this.originalImageLoaded = false;
    // this.loadImage();

    // this.addSelected(this.current + 1);
    this.currentIndex++;
  }

  getCurrentImageUrl() {
    return this.originalImageLoaded
      ? this.currentImage.previewFile.thumbnailPath
      : this.currentImage.previewFile.thumbnailPath;
  }

  onImageLoad() {
    // Called when the image (either thumbnail or original) is fully loaded
    this.originalImageLoaded = true;
  }

  private loadImage() {
    if (this.currentImage) {
      // Use the thumbnail image if available, otherwise use the original image
      const imageUrl =
        this.currentImage.previewFile.thumbnailPath ||
        this.currentImage.previewFile.thumbnailPath;
      this.image.nativeElement.src = imageUrl;
    }
  }

  private loadOriginalImage() {
    // Load the original image and trigger the onload event manually
    const originalImage = new Image();
    originalImage.src =
      this.markers[this.selectedMarkerIndex]?.originalImagePath || '';
    originalImage.onload = () => {
      this.originalImageLoaded = true;
      this.image.nativeElement.src = originalImage.src;
    };
  }

  openInSlider(index: number) {
    // this.bigImage.classList.add('animate');
    setTimeout(() => {
      //   this.bigImage.classList.remove('animate');
    }, 500);
    this.currentIndex = index;
    this.currentImage = this.images[this.currentIndex];

    this.originalImageLoaded = false;
    // this.loadImage();
  }

  onClose() {
    this.close.emit();
  }

  getFileExtensionFromUrl(url) {
    return url.split(/\#|\?/)[0].split('.').pop().trim();
  }

  downloadImage() {
    this.isDownloading = true;
    let data = [];
    let filename = this.vin ? this.vin : 'image';

    if(this.currentImage.mainFile?.path.includes('mp4')) {
      data.push(this.currentImage.mainFile);
    } else {
      data.push(this.currentImage.previewFile);
    }
    
    if (data.length < 1) {
      this.translate
        .get('vehicles.vehicle.nothingToDownload')
        .subscribe((text: string) => {
          this.toastr.info(text);
        });
      this.isDownloading = false;
      return;
    }

    let files = data.map((file) => file.path);

    this.vehicleService.downloadFiles(files).subscribe(
      (responseList) => {
        responseList.forEach((f: Blob, i: number) => {
          let fileExtension = this.getFileExtensionFromUrl(files[i]);
          const nav = window.navigator as any;
          if (nav.msSaveOrOpenBlob) {
            console.log('IE');
            nav.msSaveBlob(f, filename + fileExtension);
          } else {
            console.log('chrome');
            const a: any = document.createElement('a');
            document.body.appendChild(a);

            a.style.cssText = 'display: none';
            const url = window.URL.createObjectURL(new Blob([f]));
            a.href = url;
            a.download = `${filename}.${fileExtension}`;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
        this.isDownloading = false;
      },
      (error) => {
        // this._toastr.error(error.error.message);
        this.isDownloading = false;
      }
    );
  }

  onMouseEnter(e) {
    this.isDragging = true;
    this.startPosition = e.clientX;
    this.iframe.nativeElement.style.cursor = 'grabbing';
  }

  @HostListener('mousemove', ['$event']) onMousemove($event: MouseEvent) {
    if (this.isDragging) {
      let img = new Image();
      img.src = this.currentImage.previewFile.path;
      let aspectRatio = img.width / img.height;
      let width = this.viewportHeight * aspectRatio;
      const diffX = $event.clientX - this.startPosition;
      this.startPosition = $event.clientX;
      const backgroundPosition = getComputedStyle(
        this.iframe.nativeElement
      ).backgroundPositionX;
      const currentX = parseInt(backgroundPosition, 10) || 0;
      const newX = currentX + diffX;
      this.imageWidth = img.width;

      // Calculate the boundaries
      const minPos = -this.imageWidth + this.viewportWidth;
      const maxPos = 0;
      // Restrict panning within the boundaries
      const restrictedX = Math.min(maxPos, Math.max(minPos, newX));
      const viewWidth = width - this.viewportWidth;

      if (restrictedX >= -viewWidth) {
        this.iframe.nativeElement.style.backgroundPositionX = `${restrictedX}px`;
      } else {
        this.iframe.nativeElement.style.backgroundPositionX = `-${viewWidth}px`;
      }
    }
  }

  @HostListener('mouseup', ['$event']) onMouseup($event: MouseEvent) {
    this.isDragging = false;

    if (this.iframe) {
      this.iframe.nativeElement.style.cursor = 'grab';
    }
  }

  @HostListener('mouseleave', ['$event']) onMouseleave($event: MouseEvent) {
    if (this.isDragging) {
      this.isDragging = false;
      if (this.iframe) {
        this.iframe.nativeElement.style.cursor = 'grab';
      }
    }
  }

  ngAfterViewInit(): void {
    // this.adjustImageSize();
  }

  adjustImageSize(): void {
    const popupContent = this.elementRef.nativeElement.querySelector(
      '.image-popup-container'
    );
    const popupImage = this.elementRef.nativeElement.querySelector('.image');
    const thumbnail = this.elementRef.nativeElement.querySelector('#thumbnail');

    if (popupContent && popupImage) {
      const aspectRatio = popupImage.naturalWidth / popupImage.naturalHeight;
      const maxHeight = popupContent.clientHeight / aspectRatio;

      thumbnail.style.maxWidth = `${popupImage.naturalWidth}px`;
    }
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  videoUrl: string;

  isVideoFile(image: any): boolean {
    const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov', '.webm'];

    if (image.type === 'video') {
      this.videoUrl = image.mainFile.path;
      this.originalImageLoaded = true;
      return true;
    } else {
      const fileExtension = image.previewFile.path.substring(image.previewFile.path.lastIndexOf('.')).toLowerCase();
      if(videoExtensions.includes(fileExtension))  {
        this.videoUrl = image.previewFile.path;
        this.originalImageLoaded = true;
        return true;
      } else {
        return false;
      }
    } 
  }

  showMarkerInfo(index: number) {
    this.selectedMarkerIndex = index;

    console.log(this.markers);
    this.currentMarker = this.markers[this.selectedMarkerIndex];

    this.toggleMarkerInfo = true;
  }

  navigateMarker(direction: number) {
    if (this.selectedMarkerIndex !== null) {
      this.selectedMarkerIndex =
        (this.selectedMarkerIndex + direction + this.markers.length) %
        this.markers.length;
      this.currentMarker = this.markers[this.selectedMarkerIndex];
    }
  }
}
